import { AUDIENCE_TYPE } from "@circle-react/types/AudienceList";
import type { CurrentContact } from "@circle-react/types/CurrentContact";
import type { UseQueryOptions } from "react-query";
import { useQuery } from "react-query";

import type { ApiError } from "../config/CustomErrors";
import { reactQueryGet } from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";

const CURRENT_CONTACT_QUERY_KEY = "current-contact";

export const useCurrentContact = (
  options?: Omit<
    UseQueryOptions<void, ApiError, CurrentContact | null | undefined>,
    "queryKey"
  >,
) => {
  const queryResult = useQuery<
    void,
    ApiError,
    CurrentContact | null | undefined
  >({
    queryKey: [CURRENT_CONTACT_QUERY_KEY],
    queryFn: () => reactQueryGet(internalApi.currentContact.show()),
    ...options,
  });

  const currentContact = queryResult.data;
  const isCommunityMember =
    currentContact?.type === AUDIENCE_TYPE.COMMUNITY_MEMBER;

  return {
    currentContact,
    isCommunityMember,
    error: queryResult.error,
    isPending: queryResult.isPending,
    isFetching: queryResult.isFetching,
    refetch: queryResult.refetch,
  };
};
